/**
 * author: Patrick Vyn Badiang
 */
import { Box, Button, Typography } from "@mui/material";

//Icons
import LinkedInIcon from '@mui/icons-material/LinkedIn';

function BoardCard(props) {
    return (
        <Box sx={{ position: 'relative', width: { xs: "100px", sm: "140px", md: "180px", lg: "200px" }, height: { xs: "100px", sm: "140px", md: "180px", lg: "200px" }, borderRadius: "50%", overflow: "hidden", cursor: "pointer", "&:hover .overlay": {  opacity: 1,},}}>
            <Box component="img" src= {props.image}  alt="Profile" sx={{width:"100%", objectFit: "cover", borderRadius: "50%"}} />
                   
            <Box className="overlay" sx={{position: "absolute", top: 0, left: 0, width: "100%", height: "100%", borderRadius: "50%", bgcolor: "rgba(0,0,0,0.6)", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", opacity: 0, transition: "opacity 0.3s ease-in-out",}}>
                    <Typography variant="h6" color="primary" align='center' sx={{fontSize: { xs: "0.6rem", sm: "0.8rem", md: "1rem", lg: "1.2rem" },}}>
                      {props.position}
                    </Typography>

                    <Typography variant="h5" color="primary" align='center' sx={{fontSize: { xs: "0.8rem", sm: "1rem", md: "1.2rem", lg: "1.4rem" },}}>
                      {props.names}
                    </Typography>

                    {/** Map buttons for each name in props */}
                    {Array.isArray(props.names) && props.names.length > 0 ? (
                        props.names.map((aName, index) => (
                            <Button  
                                key={index}
                                href={props.linkedIn[index]} target="_blank"
                                color="primary" sx={{margin: "10px",  bgcolor: "#6D6FE5", borderRadius: "10px", color: "black"}} startIcon={<LinkedInIcon />}>
                                <Typography variant="body"  align='center'>
                                    {aName}
                                </Typography>
                            </Button>
                        ))
                    ) : (
                        <Button  
                            color="primary" sx={{margin: "10px",  bgcolor: "#6D6FE5", borderRadius: "10px", color: "black"}}>
                        </Button>
                    )}
                </Box>
                        
            
            
        </Box>
    );
}

export default BoardCard;